import { beAccountDeliverabilityApiGetDeliverabilityIndex } from 'Api/beAccountDeliverabilityApi'
import { ID_LIST_STORE_KEY } from 'Constants/index'
import { storeGet } from 'mailup-react-helpers'

export async function getDeliverabilityIndexSenderFlag() {
  const list = storeGet(ID_LIST_STORE_KEY)
  const result = await beAccountDeliverabilityApiGetDeliverabilityIndex({
    list
  })

  return {
    AlertsData: result?.AlertsData || {}
  }
}
